module.exports = __webpack_public_path__ + "static/media/VPM_desktop_1.e4e75d0d.jpg";